// extracted by mini-css-extract-plugin
export var cardIcon = "_8n-4";
export var checkboxCard = "_8n-0";
export var checkboxCardSelected = "_8n-3";
export var disabled = "_8n-1";
export var outerBorder = "_8n-2";
export var spacerMedium = "_8n-7";
export var spacerSmall = "_8n-6";
export var spacerXsmall = "_8n-5";